import type { Client } from '../../types/domain';
import { getActivePhase } from './activePhases';
import { isPhaseEntry, isProjectEntry, phaseIdFromEntry, projectIdFromEntry } from './identifiers';
import { getPhaseById } from './lookup';
import type { ClientAndPhase } from './types';

/* Client et phase auxquels appartient une brique, une entrée « niveau phase », ou (ancien format)
   une entrée « niveau projet » — dans ce dernier cas, la phase active du client. */
export function phaseInfoForBrique(
  clients: Client[] | null | undefined,
  briqueId: string,
  clientId?: string | null,
): ClientAndPhase | null {
  const list = clients || [];
  if (isPhaseEntry(briqueId)) return getPhaseById(list, phaseIdFromEntry(briqueId));
  if (isProjectEntry(briqueId)) {
    const c = list.find((x) => x.id === (clientId || projectIdFromEntry(briqueId)));
    if (!c) return null;
    const ph = getActivePhase(c);
    return ph ? { client: c, phase: ph } : null;
  }
  for (const c of list) {
    for (const ph of c.phases || []) {
      if ((ph.briques || []).some((b) => b.id === briqueId)) return { client: c, phase: ph };
    }
  }
  return null;
}
